import { createContext } from '@/utils';
import type { CategorySelectContextValue } from './types';

export const CategorySelectContext = createContext<
  CategorySelectContextValue | undefined
>(undefined, 'CategorySelectContext');
